import { Skeleton, Stack } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCountries } from 'src/actions'
import Countries from 'src/components/Sales/Countries'
import { IReducer } from 'src/interface'
import { getSellersGQL } from 'src/services/graphql/schemas/sellers'
import { getCountryName } from 'src/utils'
import ContactWorldSellers from './ContactWorldSellers'

export default function InternationalDealersFinder({ setCountrySelected, countrySelected }: any) {
  const dispatch = useDispatch()
  const dataContactReducer = useSelector((state: IReducer) => state.dataContactReducer)
  const dataCountriesReducer = useSelector((state: IReducer) => state.dataCountriesReducer)

  useEffect(() => {
    if (!dataContactReducer.dealersAgents.dealers.length) {
      dispatch(getSellersGQL())
    }
    if (dataCountriesReducer.countries.length === 0) {
      dispatch(getCountries())
    }
  }, [])

  const dealersByCountry = dataContactReducer.dealersAgents.dealers.filter((item) => {
    return item.Country === getCountryName(countrySelected)
  })

  return (
    <>
      {dataCountriesReducer.countries.length ? (
        <Countries
          countrySelected={countrySelected}
          setCountrySelected={setCountrySelected}
          countries={dataCountriesReducer.countries}
        />
      ) : (
        <Skeleton variant='rectangular' sx={{ width: '100%', height: 400 }} />
      )}
      {countrySelected !== 'us' && (
        <Stack>
          {dealersByCountry.map((countryItem, index: number) => (
            <ContactWorldSellers key={index} {...countryItem} />
          ))}
          {countrySelected !== 'none' && (
            <ContactWorldSellers
              ImageUrl='https://gemvision.com/Images/dynamic/salesrep/Chris.png'
              ImageAlt='Chris Burger - International Sales Rep'
              Contact='Chris Burger'
              Email='chris_burger@gemvision.com'
              PhoneNumber='800.357.6272 x5327'
            />
          )}
        </Stack>
      )}
    </>
  )
}
